import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../home/components/Footer';

export default function ServicesPage() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://documogul.com';
    
    // 设置页面标题和meta标签
    document.title = 'PDF智能处理服务 - 文档咨询、OCR识别、AI分析 | 星允信息';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '星允信息提供专业的PDF智能处理服务，包括文档工作流咨询、OCR文本识别、pdfAssistant AI、文档AI智能分析、数据结构化、权限管控、表单服务、电子签署等全方位文档智能化服务，助力企业数字化转型。');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'PDF智能处理,OCR识别,文档AI分析,电子签署,表单服务,文档咨询,数据结构化,权限管控,智能文档服务');
    }

    // 更新canonical链接
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${siteUrl}/services`);

    // 添加服务结构化数据
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "PDF智能处理服务 - 星允信息",
      "description": "提供从咨询到实施的全套智能文档服务，满足不同规模企业的多样化需求",
      "url": "https://documogul.com/services",
      "provider": {
        "@type": "Organization",
        "name": "星允信息科技有限公司",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "广州市",
          "addressRegion": "广东省",
          "addressCountry": "CN"
        }
      },
      "areaServed": {
        "@type": "Country",
        "name": "中国"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "PDF处理服务目录",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "文档工作流咨询",
              "description": "专业的文档工作流程优化咨询服务，帮助企业分析现有流程，识别瓶颈和改进机会",
              "serviceType": "Consulting"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "OCR文本识别",
              "description": "先进的光学字符识别技术服务，支持多语言识别、手写体识别、表格识别，识别准确率高达99%",
              "serviceType": "DocumentProcessing"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "pdfAssistant AI",
              "description": "基于大语言模型的智能PDF助手，支持智能问答、文档摘要、关键信息提取等AI能力",
              "serviceType": "AIService"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "文档AI智能分析",
              "description": "利用深度学习和自然语言处理技术，对文档进行深度智能分析，支持文档分类、实体识别、关系抽取",
              "serviceType": "AIService"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "文档数据结构化",
              "description": "将非结构化或半结构化的文档内容转换为标准化的结构化数据，支持发票、合同、报表等各类业务文档",
              "serviceType": "DataProcessing"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "电子签署",
              "description": "专业的电子签署解决方案，采用CA认证数字证书，确保签名法律效力，支持在线签署、批量签署、多方签署",
              "serviceType": "DigitalSignature"
            }
          }
        ]
      },
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [{
          "@type": "ListItem",
          "position": 1,
          "name": "首页",
          "item": "https://documogul.com/"
        }, {
          "@type": "ListItem",
          "position": 2,
          "name": "服务",
          "item": "https://documogul.com/services"
        }]
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  const services = [
    {
      icon: 'ri-discuss-line',
      title: '文档工作流咨询',
      category: '专业咨询服务',
      description: '为企业提供专业的文档工作流程优化咨询服务，帮助企业分析现有文档处理流程，识别瓶颈和改进机会，设计高效的文档管理解决方案。我们的专家团队将根据您的业务需求，提供定制化的工作流程优化建议和实施方案。',
      features: ['流程分析诊断', '方案设计规划', '实施指导培训', '效率提升评估', '持续优化支持', '最佳实践分享'],
      image: 'https://public.readdy.ai/ai/img_res/991b895cde341891a9a3eeff37deb196.jpg',
      price: '按项目定制',
      support: '专家顾问服务'
    },
    {
      icon: 'ri-scan-line',
      title: 'OCR文本识别',
      category: '智能识别服务',
      description: '采用先进的光学字符识别技术，精准识别各类文档中的文字内容。支持多语言识别、手写体识别、表格识别等功能，识别准确率高达99%以上。可处理扫描件、图片、PDF等多种格式，快速将非结构化文档转换为可编辑的文本数据。',
      features: ['多语言识别', '手写体识别', '表格结构识别', '高精度识别', '批量处理', '格式保持'],
      image: 'https://readdy.ai/api/search-image?query=Minimalist%20white%20background%20illustration%20with%20simple%20geometric%20shapes%20representing%20OCR%20text%20recognition%2C%20clean%20flat%20design%20with%20light%20teal%20rectangles%20and%20circles%20showing%20document%20scanning%20process%2C%20abstract%20geometric%20representation%20of%20text%20extraction%20with%20soft%20pastel%20teal%20accents%2C%20modern%20vector%20art%20style%20with%20plenty%20of%20white%20space%2C%20simple%20lines%20and%20shapes&width=800&height=500&seq=service-ocr-teal&orientation=landscape',
      price: '按页计费',
      support: '技术支持团队'
    },
    {
      icon: 'ri-robot-line',
      title: 'pdfAssistant AI',
      category: 'AI智能助手',
      description: '基于大语言模型的智能PDF助手，可以理解文档内容、回答问题、生成摘要、提取关键信息。支持自然语言交互，让您像与专家对话一样轻松处理复杂文档。提供智能问答、内容总结、信息检索等多种AI能力。',
      features: ['智能问答', '文档摘要', '关键信息提取', '多文档对比', '语义搜索', '自然语言交互'],
      image: 'https://readdy.ai/api/search-image?query=Minimalist%20white%20background%20illustration%20with%20simple%20geometric%20shapes%20representing%20AI%20assistant%2C%20clean%20flat%20design%20with%20light%20teal%20circles%20and%20abstract%20brain%20icon%2C%20geometric%20representation%20of%20chatbot%20and%20document%20analysis%20with%20soft%20pastel%20teal%20accents%2C%20modern%20vector%20art%20style%20with%20plenty%20of%20white%20space%2C%20simple%20and%20professional%20composition&width=800&height=500&seq=service-pdf-ai-teal&orientation=landscape',
      price: '订阅制服务',
      support: 'AI技术支持'
    },
    {
      icon: 'ri-brain-line',
      title: '文档AI智能分析',
      category: '智能分析服务',
      description: '利用深度学习和自然语言处理技术，对文档进行深度智能分析。自动识别文档类型、提取关键实体、分析文档结构、发现数据关联。帮助企业从海量文档中快速获取洞察，支持智能分类、情感分析、主题提取等高级功能。',
      features: ['文档分类', '实体识别', '关系抽取', '情感分析', '主题挖掘', '智能标签'],
      image: 'https://readdy.ai/api/search-image?query=Minimalist%20white%20background%20illustration%20with%20simple%20geometric%20shapes%20representing%20AI%20document%20analysis%2C%20clean%20flat%20design%20with%20light%20teal%20circles%20and%20network%20nodes%20showing%20data%20connections%2C%20abstract%20geometric%20representation%20of%20machine%20learning%20with%20soft%20pastel%20teal%20accents%2C%20modern%20vector%20art%20style%20with%20plenty%20of%20white%20space%2C%20simple%20lines%20and%20dots&width=800&height=500&seq=service-doc-ai-teal&orientation=landscape',
      price: '按调用计费',
      support: 'AI专家支持'
    },
    {
      icon: 'ri-database-line',
      title: '文档数据结构化',
      category: '数据处理服务',
      description: '将非结构化或半结构化的文档内容转换为标准化的结构化数据。支持发票、合同、报表等各类业务文档的自动化数据提取和结构化处理。提供灵活的数据映射配置，可输出JSON、XML、数据库等多种格式，无缝对接企业业务系统。',
      features: ['智能数据提取', '字段映射配置', '多格式输出', '数据验证', '批量处理', 'API集成'],
      image: 'https://readdy.ai/api/search-image?query=Minimalist%20white%20background%20illustration%20with%20simple%20geometric%20shapes%20representing%20data%20structuring%2C%20clean%20flat%20design%20with%20light%20teal%20rectangles%20and%20grid%20patterns%20showing%20database%20tables%2C%20abstract%20geometric%20representation%20of%20data%20transformation%20with%20soft%20pastel%20teal%20elements%2C%20modern%20vector%20art%20style%20with%20plenty%20of%20white%20space%2C%20simple%20and%20organized%20composition&width=800&height=500&seq=service-structure-teal&orientation=landscape',
      price: '按量计费',
      support: '数据工程师支持'
    },
    {
      icon: 'ri-shield-user-line',
      title: '文档权限管控',
      category: '安全管理服务',
      description: '提供企业级的文档权限管理和访问控制解决方案。支持细粒度的权限设置、角色管理、审批流程、操作审计等功能。确保敏感文档的安全性，防止未授权访问和数据泄露。符合ISO27001、等保等安全标准要求。',
      features: ['细粒度权限', '角色管理', '审批流程', '操作审计', '访问控制', '合规认证'],
      image: 'https://readdy.ai/api/search-image?query=Minimalist%20white%20background%20illustration%20with%20simple%20geometric%20shapes%20representing%20security%20and%20permission%20management%2C%20clean%20flat%20design%20with%20light%20teal%20shield%20icon%20and%20lock%20symbols%2C%20abstract%20geometric%20representation%20of%20access%20control%20with%20soft%20pastel%20teal%20accents%2C%20modern%20vector%20art%20style%20with%20plenty%20of%20white%20space%2C%20simple%20and%20secure%20composition&width=800&height=500&seq=service-permission-teal&orientation=landscape',
      price: '企业定制',
      support: '安全专家咨询'
    },
    {
      icon: 'ri-file-list-line',
      title: '表单服务',
      category: '智能表单服务',
      description: '提供完整的智能表单解决方案，包括表单设计、数据采集、自动填充、数据验证、流程审批等功能。支持静态表单、动态表单、交互式表单等多种类型。提供表单模板库和可视化设计器，让表单创建和管理更加简单高效。',
      features: ['可视化设计', '智能填充', '数据验证', '流程集成', '模板管理', '移动端支持'],
      image: 'https://readdy.ai/api/search-image?query=Minimalist%20white%20background%20illustration%20with%20simple%20geometric%20shapes%20representing%20digital%20forms%2C%20clean%20flat%20design%20with%20light%20teal%20rectangles%20and%20checkboxes%20showing%20form%20fields%2C%20abstract%20geometric%20representation%20of%20form%20builder%20with%20soft%20pastel%20teal%20accents%2C%20modern%20vector%20art%20style%20with%20plenty%20of%20white%20space%2C%20simple%20and%20clean%20composition&width=800&height=500&seq=service-form-teal&orientation=landscape',
      price: '订阅制服务',
      support: '专属客户经理'
    },
    {
      icon: 'ri-quill-pen-line',
      title: '电子签署',
      category: '数字签名服务',
      description: '提供专业的电子签署解决方案，支持在线签署、批量签署、多方签署等功能。采用CA认证数字证书，确保签名法律效力。支持手写签名、数字签名、时间戳等多种签署方式。提供完整的签署流程管理和审计追踪，满足合同、协议等重要文档的签署需求。',
      features: ['在线签署', 'CA数字证书', '法律效力保障', '批量签署', '多方协同', '审计追踪'],
      image: 'https://readdy.ai/api/search-image?query=Minimalist%20white%20background%20illustration%20with%20simple%20geometric%20shapes%20representing%20electronic%20signature%2C%20clean%20flat%20design%20with%20light%20teal%20pen%20and%20signature%20elements%2C%20abstract%20geometric%20representation%20of%20digital%20signing%20process%20with%20soft%20pastel%20teal%20accents%2C%20modern%20vector%20art%20style%20with%20plenty%20of%20white%20space%2C%20simple%20contract%20and%20signature%20symbols&width=800&height=500&seq=service-esign-teal&orientation=landscape',
      price: '按签署次数',
      support: '签署流程专家'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <header className="relative bg-gradient-to-br from-teal-600 via-teal-700 to-cyan-900 text-white py-24 overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://readdy.ai/api/search-image?query=Professional%20enterprise%20document%20management%20technology%20background%20with%20abstract%20geometric%20patterns%20and%20flowing%20data%20streams%2C%20modern%20corporate%20office%20environment%20with%20digital%20transformation%20elements%2C%20sophisticated%20business%20intelligence%20visualization%20with%20clean%20lines%20and%20minimalist%20design%2C%20premium%20quality%20with%20deep%20blue%20gradient%20and%20white%20accents%2C%20high-tech%20atmosphere%20showing%20document%20workflow%20automation%20and%20AI-powered%20solutions%2C%20elegant%20professional%20composition%20with%20depth%20and%20dimension&width=1920&height=600&seq=services-hero-professional&orientation=landscape"
            alt="PDF智能处理服务"
            className="w-full h-full object-cover object-top opacity-20"
          />
        </div>
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-5xl lg:text-6xl font-bold mb-6 mt-[25px]">
              <strong>专业的PDF解决方案服务</strong>
            </h1>
            <p className="text-xl lg:text-2xl text-teal-100 max-w-3xl mx-auto mb-8">
              从<strong>文档咨询</strong>到<strong>智能分析</strong>，从<strong>OCR识别</strong>到<strong>权限管控</strong>，我们提供全方位的文档智能化服务，助力企业数字化转型
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a href="#services" className="bg-white text-teal-600 px-8 py-4 rounded-lg font-semibold hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer">
                浏览服务
              </a>
              <a href="/contact" className="bg-teal-500 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-400 transition-colors whitespace-nowrap cursor-pointer border-2 border-white">
                联系咨询
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Services Grid */}
      <section id="services" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              我们的服务项目
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              提供从咨询到实施的全套智能文档服务，满足不同规模企业的多样化需求
            </p>
          </div>

          <article className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {services.map((service) => (
              <section key={service.title} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow flex flex-col h-full">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-64 object-cover object-top flex-shrink-0"
                />
                <div className="p-8 flex flex-col flex-grow">
                  <div className="flex items-center mb-4">
                    <div className="w-14 h-14 bg-teal-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                      <i className={`${service.icon} text-2xl text-white`}></i>
                    </div>
                    <div className="flex-grow">
                      <p className="text-sm text-teal-600 font-semibold mb-1">{service.category}</p>
                      <h3 className="text-2xl font-bold text-gray-900 min-h-[2.5rem] flex items-center">
                        <strong>{service.title}</strong>
                      </h3>
                    </div>
                  </div>
                  
                  <p className="text-gray-600 mb-6 leading-relaxed flex-grow min-h-[6rem]">
                    {service.description}
                  </p>

                  <div className="grid grid-cols-2 gap-3 mb-6 min-h-[7.5rem]">
                    {service.features.map((feature) => (
                      <div key={feature} className="flex items-center">
                        <i className="ri-check-line text-teal-500 text-lg mr-2 flex-shrink-0"></i>
                        <span className="text-sm text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>

                  <div className="flex items-center justify-between pt-6 border-t border-gray-200 mt-auto">
                    <div className="flex-grow">
                      <p className="text-sm text-gray-500 mb-1">定价方式</p>
                      <p className="text-lg font-bold text-teal-600">{service.price}</p>
                    </div>
                    <a 
                      href={service.title === '文档工作流咨询' ? '/document-workflow-consulting' : '/contact'} 
                      className="ml-6 bg-teal-600 hover:bg-teal-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center group"
                    >
                      <span>详情</span>
                      <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform"></i>
                    </a>
                  </div>
                </div>
              </section>
            ))}
          </article>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              为什么选择我们
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              专业的技术团队、丰富的行业经验、完善的服务体系，为您提供最优质的文档智能化解决方案
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: 'ri-award-line', title: '行业领先', desc: '10年文档技术研发经验' },
              { icon: 'ri-team-line', title: '专业团队', desc: '200+技术专家为您服务' },
              { icon: 'ri-customer-service-2-line', title: '贴心服务', desc: '7x24小时技术支持' },
              { icon: 'ri-shield-check-line', title: '安全可靠', desc: '符合国际安全标准' }
            ].map((item) => (
              <div key={item.title} className="text-center">
                <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${item.icon} text-4xl text-teal-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-teal-600 to-cyan-800 text-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            准备开始您的文档智能化之旅？
          </h2>
          <p className="text-xl text-teal-100 mb-8">
            联系我们的专业团队，获取定制化的解决方案和专业咨询服务
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a href="/contact" className="bg-white text-teal-600 px-8 py-4 rounded-lg font-semibold hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer">
              立即咨询
            </a>
            <a href="/products" className="bg-teal-500 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-400 transition-colors whitespace-nowrap cursor-pointer border-2 border-white">
              查看产品
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
